import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiPost, apiGet } from "@/lib/api-client";

interface CreateVenueBody {
  name: string;
  slug: string;
  description: string;
}

interface Venue {
  id: string;
  name: string;
  subdomain?: string;
  contactEmail?: string;
  subscriptionTier: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export function useCreateVenue() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateVenueBody) => {
      const response = await apiPost<ApiResponse<Venue>>("/venues", body as unknown as Record<string, unknown>);
      return response.data;
    },
    onSuccess: (venue) => {
      queryClient.invalidateQueries({ queryKey: ["venues"] });
      queryClient.setQueryData(["venue", venue.id], venue);
    },
  });
}

export function useGetVenue(venueId: string | null | undefined) {
  return useQuery({
    queryKey: ["venue", venueId],
    queryFn: async () => {
      if (!venueId) return null;
      const response = await apiGet<ApiResponse<Venue>>(`/venues/${venueId}`);
      return response.data;
    },
    enabled: !!venueId,
  });
}
